import * as Yup from 'yup'
import { reverseShape } from 'Components/shared/helpers/reverse-shape'
import { validBoolean, validString } from 'Components/shared/helpers/validations'

export const SlotSchema = Yup.object().shape(reverseShape({
    rackID: validString.required(),
    slotCode: validString.required(),
    remarks: validString.optional(),
    active: validBoolean.required(),
    name: validString.optional()
}))
